module.exports = __webpack_public_path__ + "static/Troglodyte-9f9bb6d82a9363f88dd3081863ed3841.jpg";